import * as R from 'ramda'
import { createSelector } from 'reselect'

import {
  employeeList,
} from './EmployeeList/selectors'
import {
  employeeImages,
} from './EmployeeImage/selectors'
import {
  FETCH_EMPLOYEE_LIST,
} from './EmployeeList/constants'
import {
  FETCH_EMPLOYEE_IMAGE,
} from './EmployeeImage/constants'

const employeeListWithImage = createSelector(
  employeeList,
  employeeImages,
  (employees, images) => {
    const usernames = R.keys(employees)
    return R.mergeDeepLeft(
      employees,
      R.pick(usernames)(images)
    )
  }
)

const isFetchingEmployeeList = state => {
  const isFetch = state.asyncActions[FETCH_EMPLOYEE_LIST]
  return isFetch ? isFetch : 0
}

const isFetchingEmployeeImage = state => {
  const isFetch = state.asyncActions[FETCH_EMPLOYEE_IMAGE]
  return isFetch ? isFetch : 0
}

const employeeListWithImageValues = state => Object.values(employeeListWithImage(state))

const isLoadingEmployeeList = createSelector(
  isFetchingEmployeeList,
  isFetchingEmployeeImage,
  (a, b) => (a + b) > 0
)

export {
  employeeListWithImage,
  employeeListWithImageValues,
  isLoadingEmployeeList,
}
